export function getArtistBookingMusicPrompt(profile = {}) {
  const artistProfile = profile || {};
  const answers = artistProfile.answers || {};
  const category = String(artistProfile.category || answers.category || "").toLowerCase();
  const policy = answers.song_request_policy || answers.song_requests || "";

  if (policy === "No") return null;

  let label;
  let placeholder;
  if (category.includes("singer") || category.includes("vocalist")) {
    label = "Song Requests / Dedications";
    placeholder = "Song dedications or songs you'd like the singer to perform…";
  } else if (category.includes("dj") || category.includes("music producer")) {
    label = "Must-Play / Do-Not-Play Tracks";
    placeholder = "Tracks to include or avoid, genres, and clean-version requests…";
  } else if (category.includes("band") || category.includes("instrumentalist") || category.includes("folk")) {
    label = "Song Requests / Setlist Preferences";
    placeholder = "Songs, artists, or styles you'd like included in the set…";
  } else {
    return null;
  }

  if (policy === "Only before event" || policy === "Only if informed in advance") {
    placeholder += " Please share requests before the event.";
  }

  return { label, placeholder };
}